import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { BrandKit, UpdateBrandKit } from '@seencast/shared';
import { request } from './client.ts';
import { qk } from './keys.ts';

// Brand kit (docs/09 §D): one per org. GET/PATCH /v1/org/brand.

export type { BrandKit, UpdateBrandKit };

export function getBrand(): Promise<BrandKit> {
  return request<BrandKit>('/org/brand');
}

export function useBrand() {
  return useQuery({ queryKey: qk.brand, queryFn: getBrand });
}

export function useUpdateBrand() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateBrandKit) =>
      request<BrandKit>('/org/brand', { method: 'PATCH', body }),
    onSuccess: (data) => {
      qc.setQueryData(qk.brand, data);
      qc.invalidateQueries({ queryKey: qk.brand });
    },
  });
}
